import { supabase } from '@/lib/supabase';

export const deleteProject = async ({ id }: { id: number }): Promise<void> => {
  const { error } = await supabase.from('projects').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
